export default __webpack_public_path__ + "static/media/record-session.247aba5f.svg";